import { AHSeparator, AHTodoCategoryIcon, Dialog, ListItem } from "arkh";
import React, { useCallback } from "react";

import { FormattedMessage } from "react-intl";
import { ScrollView } from "react-native";

import { TodoCategoryIcon } from "./__generated__/ConnectAdminInboxQuery.graphql";

export function TodoCategoryDialog(props: {
  selectedTodoCategoryId?: string;
  setSelectedTodoCategoryId: (todoCategoryId: string) => void;
  visible: boolean;
  onClose: () => void;
  todoCategories: readonly {
    id: string;
    icon: TodoCategoryIcon;
    title: string;
  }[];
}) {
  const renderItem = useCallback(
    (
      todoCategory: NonNullable<typeof props.todoCategories>[number],
      index: number
    ) => {
      const selected = props.selectedTodoCategoryId === todoCategory.id;
      return (
        <React.Fragment key={todoCategory.id}>
          {index > 0 ? <AHSeparator /> : null}
          <ListItem
            left={<AHTodoCategoryIcon icon={todoCategory.icon ?? "Check"} />}
            right={<ListItem.SingleSelectIndicator selected={selected} />}
            onPress={() => {
              props.setSelectedTodoCategoryId(todoCategory.id);
            }}
          >
            <ListItem.Title
              color={selected ? "text-primary" : "text-secondary"}
            >
              {todoCategory.title}
            </ListItem.Title>
          </ListItem>
        </React.Fragment>
      );
    },
    [props]
  );

  return (
    <Dialog
      visible={props.visible}
      onClose={props.onClose}
      minHeight={400}
      title={
        <FormattedMessage
          description="Todo Category Title"
          defaultMessage="Todo List"
        />
      }
    >
      <ScrollView style={{ flex: 1 }}>
        {props.todoCategories.map(renderItem)}
      </ScrollView>
    </Dialog>
  );
}
